module.exports = __webpack_public_path__ + "img/chae.eaba16ec.svg";